import fetch from './fetch'

export const summary = (id_pengolah = null) =>
  fetch.get('summary', { params: { id_pengolah } })

export const todayInboxSummary = () => fetch.get('summary/today/inbox')

export const todayOutboxSummary = () => fetch.get('summary/today/outbox')

export const monthlyChart = (id_pengolah = null) =>
  fetch.get('summary/monthly-chart', { params: { id_pengolah } })

export const inboxCategoriesSummary = (id_pengolah = null) =>
  fetch.get('summary/inbox-categories', { params: { id_pengolah } })
